export var redefinePublicPath = function redefinePublicPath() {// We don't support setting public path in webpack via NPM build.
};